export default {"src":"/_next/static/media/Commando-badge.eecec977.svg","height":46,"width":46};